var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"ibx-button",class:_vm.selectedClass,attrs:{"outlined":!_vm.selected,"small":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label || ''))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }